var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isVisible)?_c('tr',{staticClass:"placeholder"}):_c('tr',{class:{ 'is-selected': _vm.isSelected },on:{"click":_vm.toggleSelected}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }